import { useTranslation } from "react-i18next";
import {
  IconInfo,
  Menu,
  MenuListItem,
  IconEdit,
  IconDelete
} from "cdk-radial";
import { useRef, useState } from "react";
import Card from "./Card";
import LearnMoreDialog from '../components/Cards/LearnMoreDialog';

interface Props {
  id: string;
  description: string;
  name: string;
  iconText: string;
  url: string;
  onClick?: Function;
  onEdit?: Function;
  onDelete?: Function;
  onCardClick: Function;
  onLearnMore?: Function;
}

export interface CardMenu {
  key: string;
  label: string;
  icon?: any;
  onClick: Function
}

export const getDefaultMenuOptions = (
  t: any,
  onLearnMoreClick: Function,
  onEditClick?: Function,
  onDeleteClick?: Function,
): CardMenu[] => {
  const options = [
    { label: t('baseCard.menu.learnMore'), key:'LEARN_MORE',  icon: <IconInfo /> , onClick:onLearnMoreClick },
  ];
  
  if (onEditClick) {
    options.push({ label: t('baseCard.menu.editCard'), key: 'EDIT_CARD', icon: <IconEdit /> , onClick:onEditClick});
  }
  if (onDeleteClick) {
    options.push({ label: t('baseCard.menu.deleteCard'), key: 'DELETE_CARD', icon: <IconDelete/> , onClick:onDeleteClick});
  }
  
  return options;
};

export default function CustomAppCard({
  id,
  description,
  name,
  iconText,
  url,
  onEdit,
  onDelete,
  onCardClick,
  onLearnMore
}: Props) {

  const { t } = useTranslation();
  const menuRef = useRef();

  const [learnMoreData, setLearnMoreData] = useState({});
  const [showLearnMoreDialog, setShowLearnMoreDialog] = useState(false);

  const onLearnMoreClick = () => {
    const data = {
      iconColor: "#000",
      iconText,
      name,
      description,
    };
    setLearnMoreData(data);
    setShowLearnMoreDialog(true);
    
    if (onLearnMore) {
      onLearnMore(data);
    }
  };

  const handleEdit = () => { onEdit && onEdit({ name, description, url, appId: id }) };
  const handleDelete = () => { onDelete && onDelete({iconText, description, name, url, appId: id}) };

  const menuOptions = getDefaultMenuOptions(
    t,
    onLearnMoreClick,
    onEdit ? handleEdit : undefined,
    onDelete ? handleDelete : undefined
  );

  return (
    <>
      <Card
        iconColor={"#000"}
        iconText={iconText}
        onOpenClick={(e) => onCardClick(e as unknown as MouseEvent)}
        description={description}
        name={name}
        isEnabled={true}
        menuRef={menuRef}
      />
      <Menu labelRef={menuRef} dataTestId="bc-menu-more">
        {menuOptions.map((option: any, ind: any) => (
          <MenuListItem
            key={ind}
            isSelected={false}
            dataTestId={`lm-mn-${ind}`}
            graphicContent={option.icon}
            onClick={(e: MouseEvent) => option.onClick()}
          >
            {option.label}
          </MenuListItem>
        ))}
      </Menu>
      <LearnMoreDialog 
        learnMoreData={learnMoreData} 
        isOpen={showLearnMoreDialog} 
        onClose={() => setShowLearnMoreDialog(false)}
      />
    </>
  );
}